module.exports = __webpack_public_path__ + "img/icon.af1f2124.svg";